import { render, staticRenderFns } from "./matchDoctorList.vue?vue&type=template&id=68774513"
import script from "./matchDoctorList.vue?vue&type=script&lang=js"
export * from "./matchDoctorList.vue?vue&type=script&lang=js"
import style0 from "./matchDoctorList.vue?vue&type=style&index=0&id=68774513&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports